import type { NormalizedBaseSection } from '../types/store';
import type { APIField } from '../../fields/types/main';
import type {
  APISection,
  DynamicSection,
  DynamicSections,
  SkippedSection,
} from '../../sections/types';

type NormalizedStaticSection = NormalizedBaseSection;
type NormalizedSection =
  | NormalizedStaticSection
  | DynamicSection
  | DynamicSections
  | SkippedSection;

export const normalizeSection = (
  section: APISection,
  fieldKeyPrefix = ''
): { section: NormalizedSection; fields: APIField[] } => {
  if (section.type === 'BaseSection') {
    return {
      section: {
        ...section,
        fields: section.fields.map((field) => `${fieldKeyPrefix}${field.key}`),
      },
      fields: section.fields,
    };
  }

  if (section.type === 'SkippedSection') {
    return {
      section,
      fields: [],
    };
  }

  return { section, fields: [] };
};

export const normalizeSections = (
  sections: APISection[],
  fieldKeyPrefix = ''
): { sections: NormalizedSection[]; fields: APIField[] } => {
  const normalizedSections: NormalizedSection[] = [];
  const fields: APIField[] = [];

  sections.forEach((section) => {
    const { section: normalizedSection, fields: sectionFields } = normalizeSection(
      section,
      fieldKeyPrefix
    );
    normalizedSections.push(normalizedSection);
    fields.push(...sectionFields);
  });

  return { sections: normalizedSections, fields };
};
